import React, { ReactNode } from 'react';
import ReactDOM from 'react-dom';
import './PopupDialog.scss';

interface PopupDialogProps {
  open: boolean;
  title?: string;
  children: ReactNode;
  onClose: () => void;
  actions?: ReactNode;
  width?: number;
}

const PopupDialog: React.FC<PopupDialogProps> = ({ open, title, children, onClose, actions, width }) => {
  if (!open) return null;
  const dialog = (
    <div className="modal-backdrop">
      <div className="modal-confirm popup-dialog" style={{ position: 'relative', ...(width ? { width } : {}) }}>
        <button
          type="button"
          className="modal-close-btn"
          aria-label="Close"
          onClick={onClose}
          style={{ position: 'absolute', top: 18, right: 18, background: 'none', border: 'none', fontSize: 28, color: '#888', cursor: 'pointer', zIndex: 2 }}
        >
          &times;
        </button>
        {title && <h5>{title}</h5>}
        <div className="popup-dialog-content">{children}</div>
        {actions && <div className="modal-actions">{actions}</div>}
      </div>
    </div>
  );
  return ReactDOM.createPortal(dialog, document.body);
};

export default PopupDialog;
